export const sampleConstant = 'Sample content';

export enum AllocationStatus {
  SEGMENTATION_IN_PROGRESS = 'SEGMENTATION_IN_PROGRESS',
  NONE = 'NONE',
  CAMPAIGN_PLANNING_IN_PROGRESS = 'CAMPAIGN_PLANNING_IN_PROGRESS',
  EXECUTION_IN_PROGRESS = 'EXECUTION_IN_PROGRESS',
}
export const dividerColorCode = '#F2F4F7';
export const groupCollectionAgency = 'agency';
export const groupCollectionLender = 'allocator';
export const groupCollectionYucollectAdmin = 'yucollect_ops';

export const CAMPAIGN_PLANNER_PLAN_PARENT_NODE_ID =
  '476c5ba6-b86b-4b87-ab2d-e9570f82e087';

export const CAMPAIGN_PLANNER_PLAN_PARENT_NODE_AND_OUTREACH_ID = `${CAMPAIGN_PLANNER_PLAN_PARENT_NODE_ID}_1`;

export const ALLOCATION_ENUM_OPTIONS: any = {
  loanType: {
    '1': 'Secured',
    '2': 'Unsecured',
    '3': 'Others',
  },
  assetClass: {
    '1': 'Credit Card',
    '2': 'Personal Loan',
    '3': 'Business Loan',
    '4': 'Education Loan',
    '5': 'Home Loan',
    '6': 'Loan Against Property',
    '7': 'Auto Loan',
    '8': 'Gold Loan',
    '9': 'Agriculture Loan',
    '10': 'Others',
  },
  subAssetClass: {
    '1': 'Two Wheeler Loan',
    '2': 'Three Wheeler Loan',
    '3': 'Truck Loan',
    '4': 'Tractor Loan',
    '5': 'Others',
  },
  repaymentFreq: {
    '1': 'daily',
    '2': 'weekly',
    '3': 'monthly',
  },
  repaymentMode: {
    '1': 'Cash',
    '2': 'Nach',
    '3': 'PDC',
    '4': 'SI',
    '5': 'ECS',
    '6': 'Online',
  },
  lastPaymentMode: {
    '1': 'Cash',
    '2': 'Nach',
    '3': 'PDC',
    '4': 'SI',
    '5': 'ECS',
    '6': 'Online',
  },
};

export enum EmsMessageStatus {
  NO_LENDERS_ASSOCIATED = 'NO_LENDERS_ASSOCIATED',
  ENTITY_NOT_ONBOARDED_IN_SPOCTOX = 'ENTITY_NOT_ONBOARDED_IN_SPOCTOX',
  MY_AGENCIES_FETCHED_SUCCESSFULLY = 'MY_LENDERS_FETCHED_SUCCESSFULLY',
  REMIND_SENT_LIMIT_EXHAUSTED = 'REMIND_SENT_LIMIT_EXHAUSTED',
}

export const pillsName = [
  'campaign.channel',
  'campaign.language',
  'contentName',
  'slot',
];
export const YYYY_MM_DD = 'YYYY-MM-DD';
export const DD_MM_YYYY = 'DD-MM-YYYY';

export const APPROVAL_PENDING = 'APPROVAL PENDING';
export const PENDING = 'PENDING';
export const APPROVED = 'APPROVED';
export const REJECTED = 'REJECTED';
